/* eslint-disable camelcase */
import {
  accountDrgColumns,
  accountScopingColumns,
  basePricingXrColumns,
  blueCardAlphaPrefixesColumns,
  blueCardOpportunityColumns,
  bulkPricingResponseErrorColumns,
  claimEncounterColumns,
  claimsAccountCrosswalkHistoryColumns,
  claimsAdviceBillingProviderHistoryColumns,
  claimsAdviceClaimLineAdjustmentHistoryColumns,
  claimsAdviceMetaDataHistoryColumns,
  claimsAdvicePaymentHistoryColumns,
  claimsAdviceSubscriberHistoryColumns,
  claimsBillingProviderHistoryColumns,
  claimsClaimHistoryColumns,
  claimsMetaDataHistoryColumns,
  claimsPhysicianHistoryColumns,
  claimsServiceLineHistoryColumns,
  claimsSubscriberHistoryColumns,
  dxColumns,
  hospitalAccountColumns,
  hospitalAccountNotesColumns,
  hospitalChargesCategoriesColumns,
  hospitalChargesColumns,
  hospitalClaimsColumns,
  hospitalClinicalColumns,
  hospitalDataDocNewColumns,
  hospitalDenialsColumns,
  hospitalDiagnosisColumns,
  hospitalDrgColumns,
  hospitalEncounterColumns,
  hospitalEncounterMasterColumns,
  hospitalEncountersColumns,
  hospitalFinancialsColumns,
  hospitalGuarantorColumns,
  hospitalHimCptCategoriesColumns,
  hospitalHimCptColumns,
  hospitalInsuranceColumns,
  hospitalMotherColumns,
  hospitalNonRoomBoardColumns,
  hospitalOccurrenceCodesColumns,
  hospitalOrganizationColumns,
  hospitalPatientColumns,
  hospitalPerformingPhysicianColumns,
  hospitalPlacementCodesColumns,
  hospitalPostedChargesCategoriesColumns,
  hospitalPostedChargesColumns,
  hospitalProceduresColumns,
  hospitalRoomBoardColumns,
  icd10DiagnosisReferenceAddonColumns,
  itemizedBillColumns,
  opportunityTrackingColumns,
  opportunityXrColumns,
  proceduresColumns,
  ucsfPrefixColumns,
  wdOpportunityInfoColumns,
} from '.';

export const identificationHintList: Record<string, string[]> = {
  account_scoping: [...accountScopingColumns],
  account_scoping_latest: [...accountScopingColumns],
  identification_base_xr: [...basePricingXrColumns],
  identification_opportunity_xr: [...opportunityXrColumns],
  opportunity_tracking: [...opportunityTrackingColumns],
  opportunity_tracking_latest: [...opportunityTrackingColumns],
  bluecard_opportunity: [...blueCardOpportunityColumns],
  bulk_pricing_response_errors: [...bulkPricingResponseErrorColumns],
  primary_xr: [...basePricingXrColumns],
  opportunity_xr: [...opportunityXrColumns],
};

export const hospitalHintList: Record<string, string[]> = {
  hospital__account_notes: [...hospitalAccountNotesColumns],
  hospital__account: [...hospitalAccountColumns],
  hospital__claims: [...hospitalClaimsColumns],
  hospital__clinical: [...hospitalClinicalColumns],
  hospital__charges: [...hospitalChargesColumns],
  hospital__charges_categories: [...hospitalChargesCategoriesColumns],
  hospital__charges_filtered: [...hospitalChargesColumns],
  hospital__data_doc_new: [...hospitalDataDocNewColumns],
  hospital__denials: [...hospitalDenialsColumns],
  hospital__diagnosis: [...hospitalDiagnosisColumns],
  hospital__drg: [...hospitalDrgColumns],
  hospital__encounter: [...hospitalEncounterColumns],
  hospital__encounter_master: [...hospitalEncounterMasterColumns],
  hospital__encounters: [...hospitalEncountersColumns],
  hospital__financials: [...hospitalFinancialsColumns],
  hospital__guarantor: [...hospitalGuarantorColumns],
  hospital__him_cpt: [...hospitalHimCptColumns],
  hospital__him_cpt_categories: [...hospitalHimCptCategoriesColumns],
  hospital__insurance: [...hospitalInsuranceColumns],
  hospital__mother: [...hospitalMotherColumns],
  hospital__non_room_board: [...hospitalNonRoomBoardColumns],
  hospital__occurrence_codes: [...hospitalOccurrenceCodesColumns],
  hospital__organization: [...hospitalOrganizationColumns],
  hospital__patient: [...hospitalPatientColumns],
  hospital__performing_physician: [...hospitalPerformingPhysicianColumns],
  hospital__placement_codes: [...hospitalPlacementCodesColumns],
  hospital__posted_charges: [...hospitalPostedChargesColumns],
  hospital__procedures: [...hospitalProceduresColumns],
  hospital__posted_charges_categories: [...hospitalPostedChargesCategoriesColumns],
  hospital__room_board: [...hospitalRoomBoardColumns],
};

export const eightThirtySevenHintList: Record<string, string[]> = {
  claims_account_crosswalk__history: [...claimsAccountCrosswalkHistoryColumns],
  claims_advice_billing_provider__history: [...claimsAdviceBillingProviderHistoryColumns],
  claims_advice_claim_line_adjustment__history: [...claimsAdviceClaimLineAdjustmentHistoryColumns],
  claims_advice_meta_data__history: [...claimsAdviceMetaDataHistoryColumns],
  claims_advice_payment__history: [...claimsAdvicePaymentHistoryColumns],
  claims_advice_subscriber__history: [...claimsAdviceSubscriberHistoryColumns],
  claims_billing_provider__history: [...claimsBillingProviderHistoryColumns],
  claims_claim__history: [...claimsClaimHistoryColumns],
  claims_meta_data__history: [...claimsMetaDataHistoryColumns],
  claims_physician__history: [...claimsPhysicianHistoryColumns],
  claims_service_line__history: [...claimsServiceLineHistoryColumns],
  claims_subscriber__history: [...claimsSubscriberHistoryColumns],
};

export const identification837ViewHintList: Record<string, string[]> = {
  account_drg: [...accountDrgColumns],
  claim_encounter: [...claimEncounterColumns],
  dx: [...dxColumns],
  itemized_bill: [...itemizedBillColumns],
  procedures: [...proceduresColumns],
  hospital__diagnosis_with_ref: [...hospitalDiagnosisColumns, ...icd10DiagnosisReferenceAddonColumns],
};

export const identificationAdhocHintList: Record<string, string[]> = {
  blue_card_alpha_prefixes: [...blueCardAlphaPrefixesColumns],
  uscf_prefixes: [...ucsfPrefixColumns],
  wd_opportunity_info: [...wdOpportunityInfoColumns],
};

export const fullHintList: Record<string, string[]> = {
  ...hospitalHintList,
  ...identificationHintList,
  ...eightThirtySevenHintList,
  ...identification837ViewHintList,
  ...identificationAdhocHintList,
};

export const hospitalV2TableNames = Object.keys(fullHintList);
